import { SvgIconProps } from '@mui/material/SvgIcon';
import { Icon } from '@/units/index';
import { CardPriority } from '../..';

type Props = SvgIconProps & {
  priority: CardPriority;
};

export function PriorityIcon({ priority, ...props }: Props) {
  if (priority === CardPriority.Lowest) {
    return <Icon.LowestPriority {...props} />;
  }

  if (priority === CardPriority.Lower) {
    return <Icon.LowerPriority {...props} />;
  }

  if (priority === CardPriority.Low) {
    return <Icon.LowPriority {...props} />;
  }

  if (priority === CardPriority.Medium) {
    return <Icon.MediumPriority {...props} />;
  }

  if (priority === CardPriority.High) {
    return <Icon.HighPriority {...props} />;
  }

  if (priority === CardPriority.Highest) {
    return <Icon.HighestPriority {...props} />;
  }

  return <Icon.MediumPriority {...props} />;
}
